import { css } from 'styled-components';
import { MainContentProps } from './models';

export const MainContentPadding = 20;
export const MainContentTopPaddingMobile = 40;
export const MainContentTopPaddingDesktop = 58;

export const MainContent = css<MainContentProps>(({ theme }) => {
  return css`
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    overflow-x: hidden;
    padding: ${MainContentTopPaddingMobile}px ${MainContentPadding}px ${MainContentPadding}px;

    @media only screen and ${theme.device.mobileXL} {
      padding-top: ${MainContentTopPaddingDesktop}px;
    }

    &.no-padding {
      padding: 0;
    }
  `;
});
